import { render, staticRenderFns } from "./BookDepartmentCard.vue?vue&type=template&id=6629dcc5&"
import script from "./BookDepartmentCard.vue?vue&type=script&lang=ts&"
export * from "./BookDepartmentCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports